import React, { useEffect, useState } from "react";
import Adminhomemenu from "../Menus/Adminhomemenu";

export default function Adminhome() {
  const user = JSON.parse(localStorage.getItem("user"));

  const [visits, setVisits] = useState(0);

  useEffect(() => {
    const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_GET_VISITOR_COUNT}`;

    fetch(path, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}), // 👈 empty body safe
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.res === "Success") {
          setVisits(data.data.visitor_num);
        }
      })
      .catch((err) => {
        console.log("Visitor counter error", err);
      });
  }, []);

  return (
    <>
      <Adminhomemenu title="EasyITI" testhistory="testhistory" />

      <div
        style={{ minHeight: "100vh", height: "auto", background: "#f4f6f9" }}
      >
        <div
        className="container"
        style={{
          paddingTop: "90px",
          height: "auto",
        }}
      >
          {/* 🔹 Welcome Card */}
          <div
            className="card shadow-sm mb-4 border-0"
            style={{ height: "auto" }}
          >
            <div
              className="card-body d-flex align-items-center justify-content-between"
              style={{ height: "auto" }}
            >
              <div>
                <h4 className="mb-1">Welcome 👋</h4>
                <h5 className="text-primary fw-bold">
                  {user?.FULL_NAME || "Admin"}
                </h5>
                <p className="text-muted mb-0">
                  Manage tests, students and results from one place
                </p>
              </div>
              <div className="text-end">
                <span className="badge bg-success px-3 py-2 mb-2">
                  Admin Panel
                </span>
                <div className="small text-muted">
                  👀 Visits: <b>{visits}</b>
                </div>
              </div>
            </div>
          </div>

          {/* 🔹 Quick Action Cards */}
          <div className="row">
            {/* Create Test */}
            <div className="col-md-3 mb-3">
              <div className="card shadow h-100 border-0">
                <div className="card-body text-center">
                  <div className="fs-1 mb-2">📝</div>
                  <h6>Create Test</h6>
                  <p className="text-muted small">Create manual MCQ test</p>
                  <a
                    href="/easyiti/createtest"
                    className="btn btn-primary btn-sm"
                  >
                    Create
                  </a>
                </div>
              </div>
            </div>

            {/* Create Random Test */}
            <div className="col-md-3 mb-3">
              <div className="card shadow h-100 border-0">
                <div className="card-body text-center">
                  <div className="fs-1 mb-2">🎯</div>
                  <h6>Create Random Test</h6>
                  <p className="text-muted small">
                    Auto-generate random questions
                  </p>
                  <a
                    href="/easyiti/createrendomtest"
                    className="btn btn-danger btn-sm"
                  >
                    Generate
                  </a>
                </div>
              </div>
            </div>

            {/* ✅ Create Paper (NEW FEATURE 🔥) */}
            <div className="col-md-3 mb-3">
              <div
                className="card shadow h-100 border-0"
                style={{
                  background: "linear-gradient(135deg, #667eea, #764ba2)",
                  color: "white",
                  position: "relative",
                }}
              >
                {/* NEW Tag */}
                <span
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    background: "#ffcc00",
                    color: "#000",
                    padding: "4px 8px",
                    borderRadius: "20px",
                    fontSize: "11px",
                    fontWeight: "bold",
                  }}
                >
                  ✨ NEW
                </span>

                <div className="card-body text-center">
                  <div className="fs-1 mb-2">📄</div>
                  <h6>Create Paper</h6>
                  <p className="small" style={{ opacity: 0.9 }}>
                    Generate printable exam paper
                  </p>
                  <a
                    href="/easyiti/createquestionpaper"
                    className="btn btn-light btn-sm"
                  >
                    Create
                  </a>
                </div>
              </div>
            </div>

            {/* Test History */}
            <div className="col-md-3 mb-3">
              <div className="card shadow h-100 border-0">
                <div className="card-body text-center">
                  <div className="fs-1 mb-2">📊</div>
                  <h6>Test History</h6>
                  <p className="text-muted small">
                    View test results & students
                  </p>
                  <a
                    href="/easyiti/testhistory"
                    className="btn btn-success btn-sm"
                  >
                    View
                  </a>
                </div>
              </div>
            </div>

            {/* Students */}
            <div className="col-md-3 mb-3">
              <div className="card shadow h-100 border-0">
                <div className="card-body text-center">
                  <div className="fs-1 mb-2">👨‍🎓</div>
                  <h6>Students</h6>
                  <p className="text-muted small">
                    Student performance overview
                  </p>
                  <button className="btn btn-warning btn-sm" disabled>
                    Coming Soon
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Info Strip */}
          <div className="alert alert-info mt-4 shadow-sm">
            <b>Tip:</b> Random tests help students practice with new questions
            every time.
          </div>
        </div>
      </div>
    </>
  );
}
